// extracted by mini-css-extract-plugin
module.exports = {"promotionActivitiesTable":"-promotion-activities-table-promotionActivitiesTable-2kCad2-"};